module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.tagplayContainer
  }, [_c('div', {
    staticClass: "tagplay-widget",
    attrs: {
      "id": "tagplay-widget-1c6bd9",
      "data-project": "04d7b70a-aaa4-4c51-9c0b-78f12c0c98ce",
      "data-feed": "1c6bd967-1cd7-4be7-a512-ad651683f011",
      "data-token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImVpbmFyQHNpbGZyYS5pcyIsImFwaV9rZXkiOiJhOGJkY2NmNmE0NWUzMWI4MTA1NzY0ZGQyMjYwNmZkZTMxNzYwNjRlIiwiZmVlZElkIjoiMWM2YmQ5NjctMWNkNy00YmU3LWE1MTItYWQ2NTE2ODNmMDExIiwiaWF0IjoxNDk0NDIzMTg1fQ.AZz4jX968CTcL25Ir_59P1flaSgmc0qzuIbTW7HgAMI",
      "data-include-usernames": "",
      "data-include-captions": "",
      "data-include-link-metadata": "",
      "data-rows": "120",
      "data-cols": _vm.cols,
      "data-spacing": "10",
      "data-hashtags": "show",
      "data-style": "minimal",
      "data-type": "grid",
      "data-responsive": "",
      "data-lightbox": "",
      "data-trigger-tags": "góðarsögur,godarsogur",
      "data-num-media": "360",
      "data-client": "[object Object]"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6c72e88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagplayWidget.vue
// module id = 31
// module chunks = 0